var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs6":"","sm5":""}},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","label":"Ordenação","persistent-hint":"","return-object":"","single-line":""},model:{value:(_vm.ordination),callback:function ($$v) {_vm.ordination=$$v},expression:"ordination"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }